export function PreloadData(): JSX.Element {
  return (
    <div id="preload-data" style={{ display: 'block', position: 'absolute', left: '-500px', opacity: 0 }}>
      <span style={{ fontFamily: 'FontAwesome' }}>.</span>
    </div>
  );
}
